import { useEffect, useRef, useState } from 'react';
import { getThumbnail } from './thumbnailFactory';
import { assetUrl } from '../../../assets/thornhavenAssetRegistry';

/** Lazy 3D thumbnail: generates only once the tile scrolls into view; the
 *  shared factory serializes + caches work so revisits are instant. */
export default function AssetThumb({ assetId }) {
  const ref = useRef(null);
  const [src, setSrc] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) setVisible(true);
      },
      { rootMargin: '300px' }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    let alive = true;
    getThumbnail(assetUrl(assetId)).then((d) => {
      if (alive) setSrc(d);
    });
    return () => {
      alive = false;
    };
  }, [visible, assetId]);

  return (
    <div
      ref={ref}
      className="w-full aspect-square flex items-center justify-center bg-gradient-to-br from-stone-800 to-stone-900 rounded-lg overflow-hidden"
    >
      {src ? (
        <img src={src} alt="" className="w-full h-full object-contain" draggable={false} />
      ) : (
        <div className="w-6 h-6 border-2 border-amber-500/40 border-t-amber-400 rounded-full animate-spin" />
      )}
    </div>
  );
}
